export const ENV = {
  API_URL: process.env.REACT_APP_API_URL,
  WEB_TOKEN: process.env.REACT_APP_WEB_TOKEN,
};